import React from 'react'
import { Modal } from 'react-bootstrap'
import { IMeetingRoomSolicitationDetail } from '../types'
import { IMeetingRoomReservationDetail } from '../../manage-meeting-room/MeetingRoomReservationsTable/types'
import {
  FieldGroup,
  FieldLabel,
  FieldRow,
  FieldRowGrid,
  FieldValue,
  StyledModal,
  ACCESS_TIME_ICON_URL,
  CALENDAR_ICON_URL,
  CalendarFieldIcon,
  TimeFieldIcon,
  TimeFieldValue,
} from './styles'

interface SolicitationDetailModalProps {
  solicitation: IMeetingRoomSolicitationDetail | IMeetingRoomReservationDetail | null
  onClose: () => void
}

export const SolicitationDetailModal = ({
  solicitation,
  onClose,
}: SolicitationDetailModalProps): JSX.Element => {
  const isOpen = solicitation !== null

  return (
    <StyledModal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Detalhes da Reserva</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {solicitation && (
          <FieldGroup>
            <FieldRow>
              <FieldLabel>Nome completo</FieldLabel>
              <FieldValue>{solicitation.requesterFullName}</FieldValue>
            </FieldRow>
            <FieldRow>
              <FieldLabel>Nome da organização</FieldLabel>
              <FieldValue>{solicitation.requesterInstitutionName}</FieldValue>
            </FieldRow>
            <FieldRow>
              <FieldLabel>E-mail</FieldLabel>
              <FieldValue>{solicitation.requesterEmail}</FieldValue>
            </FieldRow>
            <FieldRow>
              <FieldLabel>Telefone</FieldLabel>
              <FieldValue>{solicitation.requesterWhatsapp}</FieldValue>
            </FieldRow>
            <FieldRow>
              <FieldLabel>Nome do evento</FieldLabel>
              <FieldValue>{solicitation.eventName}</FieldValue>
            </FieldRow>
            <FieldRow>
              <FieldLabel>Descrição</FieldLabel>
              <FieldValue>{solicitation.eventDescription}</FieldValue>
            </FieldRow>
            <FieldRowGrid>
              <FieldRow>
                <FieldLabel>Data de início</FieldLabel>
                <TimeFieldValue>
                  <CalendarFieldIcon src={CALENDAR_ICON_URL} alt="" aria-hidden />
                  {solicitation.startDate}
                </TimeFieldValue>
              </FieldRow>
              <FieldRow>
                <FieldLabel>Data de término</FieldLabel>
                <TimeFieldValue>
                  <CalendarFieldIcon src={CALENDAR_ICON_URL} alt="" aria-hidden />
                  {solicitation.endDate}
                </TimeFieldValue>
              </FieldRow>
            </FieldRowGrid>
            <FieldRowGrid>
              <FieldRow>
                <FieldLabel>Hora de início</FieldLabel>
                <TimeFieldValue>
                  <TimeFieldIcon src={ACCESS_TIME_ICON_URL} alt="" aria-hidden />
                  {solicitation.startTime}
                </TimeFieldValue>
              </FieldRow>
              <FieldRow>
                <FieldLabel>Hora de término</FieldLabel>
                <TimeFieldValue>
                  <TimeFieldIcon src={ACCESS_TIME_ICON_URL} alt="" aria-hidden />
                  {solicitation.endTime}
                </TimeFieldValue>
              </FieldRow>
            </FieldRowGrid>
            <FieldRow>
              <FieldLabel>Quantidade de pessoas</FieldLabel>
              <FieldValue>{solicitation.attendeesCount}</FieldValue>
            </FieldRow>
          </FieldGroup>
        )}
      </Modal.Body>
    </StyledModal>
  )
}
